<template>
    <DatePicker
        ref="dp"
        transfer
        style="width: 100%"
        v-if="cellEditing || cellEditable"
        :readonly="!cellEditing || $attrs.readonly"
        v-bind="$attrs"
        v-on="editEvents"
        v-model="dateVal"
    >
    </DatePicker>
    <cell-render
        v-else-if="render"
        :render="render"
        :context="$props"
    ></cell-render>
    <div v-else :class="prefixCls + '-wrap-readonly'" data-cls="cell-content">
        <slot>
            <span>{{ value }}</span>
        </slot>
    </div>
</template>
<script>
import mixin from './mixin'
import DatePicker from '../date-picker'

export default {
    mixins: [mixin],

    components: {
        DatePicker,
    },

    name: 'CellDatePicker',

    computed: {
        dateVal: {
            get() {
                return this.value ? new Date(this.value) : ''
            },

            set(val) {
                this.onChange(this.$refs.dp.publicStringValue)
            },
        },
    },
}
</script>
